import { AxiosInstance } from "axios";
import { IEmailApproval } from "../../interface/emails/IEmailApproval";
import { ApiService } from "../../model/Api.model";

enum EmailApprovalServiceEnum {
  approve = "/approve",
  reject = "/reject"
}

export default class EmailApprovalService extends ApiService {
  constructor(restClient: AxiosInstance) {
    super(restClient, "/email", false);
  }

  public approve = async (eventKey: string, uidKey: string, request: IEmailApproval) => await this.POST(`${EmailApprovalServiceEnum.approve}/${eventKey}/${uidKey}`, request);

  public reject = async (eventKey: string, uidKey: string, request: IEmailApproval) => await this.POST(`${EmailApprovalServiceEnum.reject}/${eventKey}/${uidKey}`, request);
}



// WEBPACK FOOTER //
// ./src/services/api/email/EmailApproval.service.ts